import {ProductOrdersList} from "../../common/formElements";
import {getSlotSet} from "../../common/formElements/ProductOrdersList/fieldSets";
import CancelledAndMovedOrdersList from "../../common/formElements/CancelledAndMovedOrdersList";
import TinkoffIdField from "../../common/formElements/TinkoffIdField";
import {t} from "i18next";
import React from "react";
import {useHistory, useParams} from "react-router-dom";

const SlotOrders = ({dispatch, state, edit}) => {
    let history = useHistory();
    let {url, event_url, slot_url} = useParams();

    const transferBtn = (
        <div className={'btn-group'}>
            <button className={'btn-sm btn btn-outline-secondary'} onClick={() => history.push(`/bases/${url}/event/${event_url}/slot/${slot_url}/transfer`)}>{t('common.productOrderList.transfer')}</button>
        </div>
    )

    return (
        <>
            <ProductOrdersList dispatch={dispatch} state={state} product_type={'slots'} showExp disabled={!edit} customButton={transferBtn}/>
            <CancelledAndMovedOrdersList
                name={"slots_orders-moved-and-cancelled-list"}
                fields={[
                    ...getSlotSet(),
                    ...TinkoffIdField(),
                ]}
                entity={state}
                entityOrderName={'slot_id'}
                reload={state.reload} />
        </>
    )
}

export default SlotOrders